import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { useInView } from "./AnimatedComponents";

interface SectionTitleProps {
  title: string;
  span: string;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ title, span }) => {
  const { ref, inView } = useInView(0.2);

  return (
    <TitleStyled ref={ref}>
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
        transition={{ duration: 0.5, ease: [0.25, 0.1, 0.25, 1] }}
      >
        {title}
        <span className="background-text">{span}</span>
      </motion.h2>
      <div className="underline">
        <motion.div
          className="line"
          initial={{ width: 0 }}
          animate={inView ? { width: "5rem" } : { width: 0 }}
          transition={{ duration: 0.6, delay: 0.2, ease: [0.25, 0.1, 0.25, 1] }}
        />
        <motion.div
          className="line accent"
          initial={{ width: 0 }}
          animate={inView ? { width: "2.5rem" } : { width: 0 }}
          transition={{ duration: 0.5, delay: 0.4, ease: [0.25, 0.1, 0.25, 1] }}
        />
      </div>
    </TitleStyled>
  );
};

const TitleStyled = styled.div`
  position: relative;
  margin-bottom: 1rem;

  h2 {
    font-size: 2.5rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: -0.02em;
    position: relative;
    display: inline-block;

    @media screen and (max-width: 600px) {
      font-size: 2rem;
    }

    .background-text {
      font-weight: 900;
      color: var(--border-color);
      font-size: 4.5rem;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      z-index: -1;
      opacity: 0.4;
      white-space: nowrap;
      text-transform: uppercase;
      letter-spacing: 0.05em;

      @media screen and (max-width: 600px) {
        font-size: 3rem;
      }
    }
  }

  .underline {
    position: relative;
    margin-top: 0.75rem;
    height: 3px;
    display: flex;

    .line {
      width: 5rem;
      height: 100%;
      background-color: var(--border-color);
      border-radius: 10px;
    }

    .line.accent {
      width: 2.5rem;
      background: linear-gradient(
        90deg,
        var(--primary-color),
        var(--primary-color-light)
      );
      margin-left: -2.5rem;
      border-radius: 10px;
    }
  }
`;

export default SectionTitle;
